<template lang="pug">
    .digital-edit__form
        SvButton.digital-edit__button-top(
            v-show="visibleToTop"
            :prependIcon=`{
                icon: 'arrow-up',
                width: 10,
                height: 15,
            }`
            view="flat"
            text="Наверх"
            @click="scrollToTop"
        )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Активность

            .digital-edit__form-elements--small.radio
                SvRadio.digital-edit__form-radio(
                    v-model="is_active"
                    :value="true"
                    label="Да"
                )

                SvRadio.digital-edit__form-radio(
                    v-model="is_active"
                    :value="false"
                    label="Нет"
                )

        .digital-edit__form-item.digital-edit__form-item_section-title
            span.digital-edit__form-title

            .digital-edit__form-elements--medium
                .digital-edit__section-title
                    | Превью

        .digital-edit__form-item
            span.digital-edit__form-title
                | Изображение превью

            .digital-edit__form-elements--medium
                SvUpload.form-residential-photo__upload(
                    v-model="preview_image"
                    :class="{ 'form-residential-photo__upload--no-image': !preview_image }"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Логотип

            .digital-edit__form-elements--medium
                SvUpload.form-residential-photo__upload(
                    v-model="logo"
                    :class="{ 'form-residential-photo__upload--no-image': !logo }"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Скрыть логотип на&nbsp;детальной странице

            .digital-edit__form-elements--medium.digital-edit__form-elements--flex-col
                SvCheckbox(
                    v-model="hide_logo_in_details"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Название ЖК

            .digital-edit__form-elements--medium
                SvInput(
                    v-model="name_preview"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item.digital-edit__form-item_section-title
            span.digital-edit__form-title

            .digital-edit__form-elements--medium
                .digital-edit__section-title
                    | Главная

        .digital-edit__form-item
            span.digital-edit__form-title
                | Название

            .digital-edit__form-elements--medium
                SvInput(
                    v-model="name"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Символьный код

            .digital-edit__form-elements--small
                SvInput(
                    v-model="alias"
                    color="graylight"
                    :withIcon="false"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Изображение ЖК

            .digital-edit__form-elements--medium
                SvUpload.form-residential-photo__upload(
                    v-model="detail_image"
                    :class="{ 'form-residential-photo__upload--no-image': !detail_image }"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | Итоговые цифры

            .digital-edit__form-elements--medium
                SvMultipleInputs.form-residential-photo__upload(
                    v-model="numbers"
                    :inputs="['number', 'name']"
                )

        .digital-edit__form-item
            span.digital-edit__form-title
                | О компании

            .digital-edit__form-elements--medium
                SvTextarea(
                    v-model="about"
                    placeholder="Например: Flora&Fauna это жилой комплекс премиум-класса в сосновом бору на берегу реки, который состоит из 13 домов..."
                    :rows="4"
                )


        .digital-edit__form-item.digital-edit__form-item_section-title
            span.digital-edit__form-title

            .digital-edit__form-elements--medium
                .digital-edit__section-title
                    | Задачи

        .digital-edit__form-item
            span.digital-edit__form-title
                | Описание

            .digital-edit__form-elements--medium
                ckeditor(
                    v-model="tasks"
                    :editor="editor"
                    :config="editorConfig"
                )

        .digital-edit__form-item.digital-edit__form-item_section-title
            span.digital-edit__form-title

            .digital-edit__form-elements--medium
                .digital-edit__section-title
                    | Аудит

        .digital-edit__form-item
            span.digital-edit__form-title

            .digital-edit__form-elements--medium
                ckeditor(
                    v-model="audit"
                    :editor="editor"
                    :config="editorConfig"
                )

        .digital-edit__form-item.digital-edit__form-item_section-title
            span.digital-edit__form-title

            .digital-edit__form-elements--medium
                .digital-edit__section-title
                    | Решение

        .digital-edit__form-item
            span.digital-edit__form-title
                | Описание

            .digital-edit__form-elements--medium
                ckeditor(
                    v-model="solution"
                    :editor="editor"
                    :config="editorConfig"
                )

            span.digital-edit__form-title

            .digital-edit__form-elements
                .digital-edit-plans__form
                    .digital-edit-plans__form-item(
                        v-for="(solution, index) in solutionsWithEmpty"
                    )
                        SolutionEmpty(
                            v-if="!solution"
                            @uploaded="addPlans"
                        )

                        SolutionForm(
                            v-else
                            :value="solutionsWithEmpty[index]"
                            @remove="removeSolution(index)"
                        )

            span.digital-edit__form-title
                | Описание

            .digital-edit__form-elements--medium
                ckeditor(
                    v-model="solution_conclusion"
                    :editor="editor"
                    :config="editorConfig"
                )

        .digital-edit__form-item.digital-edit__form-item_section-title
            span.digital-edit__form-title

            .digital-edit__form-elements--medium
                .digital-edit__section-title
                    | Ход работы

        .digital-edit__form-item(
            v-for="(stage, index) in stages"
        )
            span.digital-edit__form-title
                | Описание

            .digital-edit__form-elements--medium
                SvInput(
                    v-model="stage.title"
                    color="graylight"
                    :withIcon="false"
                    placeholder="Заголовок шага"
                    class="mb20"
                )
                SvInput(
                    v-model="stage.subtitle"
                    color="graylight"
                    :withIcon="false"
                    placeholder="Подзаголовок шага"
                    class="mb20"
                )

                ckeditor(
                    v-model="stage.description"
                    :editor="editor"
                    :config="editorConfig"
                )

        .digital-edit__form-item
            span.digital-edit__form-title

            SvButton.plan-empty__button(
                view="bordered"
                text="Добавить шаг"
                @click="addStage()"
            )

        .digital-edit__form-item.digital-edit__form-item_section-title
            span.digital-edit__form-title

            .digital-edit__form-elements--medium
                .digital-edit__section-title
                    | Итоговые цифры

        .digital-edit__form-item
            span.digital-edit__form-title
                | Описание

            .digital-edit__form-elements--medium
                ckeditor(
                    v-model="totals"
                    :editor="editor"
                    :config="editorConfig"
                )
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import SvCheckbox from '@/components/uikit/SvCheckbox.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvMap from '@/components/uikit/SvMap.vue';
import SvSelect from '@/components/uikit/SvSelect.vue';
import SvDatePicker from '@/components/uikit/SvDatePicker.vue';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvSelectList from '@/components/uikit/SvSelectList.vue';
import SvInputList from '@/components/uikit/SvInputList.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvSelectInputList from '@/components/uikit/SvSelectInputList.vue';
import SvDoubleInputList from '@/components/uikit/SvDoubleInputList.vue';
import {rusToLatin} from '@/helpers/transform';
import SvUpload from '@/components/uikit/SvUpload.vue';
import SvTextarea from '@/components/uikit/SvTextarea.vue';
import SvMultipleInputs from '@/components/uikit/SvMultipleInputs.vue';
import '@ckeditor/ckeditor5-build-classic/build/translations/ru';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SolutionEmpty from "@/components/forms/subforms/SolutionEmpty";
import SolutionForm from "@/components/forms/subforms/SolutionForm";

export default {
    name: 'FormDigitalCases',

    data() {
        return {
            geoVisible: false,
            visibleToTop: false,

            editor: ClassicEditor,
            editorConfig: {
                ckfinder: {
                    // Upload the images to the server using the CKFinder QuickUpload command.
                    uploadUrl: '/admin/products/' + this.$route.params.id + '/upload-inline-image',

                    // Define the CKFinder configuration (if necessary).
                    options: {
                        resourceType: 'Images',
                        pass: 5,
                    },
                },
                toolbar: {
                    viewportTopOffset: 0,
                },
                language: 'ru',
            },
        };
    },

    mounted() {
        window.addEventListener('scroll', () => {
            this.scrolled();
        });
    },

    computed: {
        ...mapGetters({
            current: 'digital/getCurrent',
        }),

        id: () => this.current.is_active,

        is_active: {
            get() {
                return this.current.is_active;
            },
            set(is_active) {
                this.setValue({is_active});
            },
        },

        name_preview: {
            get() {
                return this.current.name_preview;
            },
            set(name_preview) {
                this.setValue({name_preview});
            },
        },

        name: {
            get() {
                return this.current.name;
            },
            set(name) {
                this.setValue({name});
                this.setValue({alias: rusToLatin(name)});
            },
        },

        alias: {
            get() {
                return this.current.alias;
            },
            set(alias) {
                this.setValue({alias});
            },
        },

        logo: {
            get() {
                return this.current.logo;
            },

            set(logo) {
                this.setValue({ logo });
            },
        },

        hide_logo_in_details: {
            get() {
                return this.current.hide_logo_in_details;
            },

            set(hide_logo_in_details) {
                this.setValue({ hide_logo_in_details });
            },
        },

        detail_image: {
            get() {
                return this.current.detail_image;
            },

            set(detail_image) {
                this.setValue({ detail_image });
            },
        },

        preview_image: {
            get() {
                return this.current.preview_image;
            },

            set(preview_image) {
                this.setValue({ preview_image });
            },
        },

        numbers: {
            get() {
                return this.current.numbers;
            },

            set(numbers) {
                this.setValue({ numbers });
            },
        },

        about: {
            get() {
                return this.current.about;
            },

            set(about) {
                this.setValue({ about });
            },
        },

        tasks: {
            get() {
                return this.current.tasks;
            },

            set(tasks) {
                this.setValue({ tasks });
            },
        },

        audit: {
            get() {
                return this.current.audit;
            },

            set(audit) {
                this.setValue({ audit });
            },
        },

        totals: {
            get() {
                return this.current.totals;
            },

            set(totals) {
                this.setValue({ totals });
            },
        },

        solution: {
            get() {
                return this.current.solution;
            },

            set(solution) {
                this.setValue({ solution });
            },
        },

        solution_conclusion: {
            get() {
                return this.current.solution_conclusion;
            },

            set(solution_conclusion) {
                this.setValue({ solution_conclusion });
            },
        },

        solutions: {
            get() {
                return this.current.solutions;
            },

            set(solutions) {
                this.setValue({ solutions });
            },
        },

        solutionsWithEmpty() {
            return [...this.solutions, null];
        },

        stages: {
            get() {
                return this.current.stages;
            },

            set(stages) {
                this.setValue({ stages });
            },
        },
    },

    methods: {
        ...mapMutations({
            setValue: 'digital/setValue',
        }),

        scrolled() {
            if (window.pageYOffset > 700) {
                this.visibleToTop = true;
            } else {
                this.visibleToTop = false;
            }
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        addPlans(val) {
            this.solutions = [
                ...this.solutions,
                ...[{
                    icon: val,
                    description: '',
                    items: [],
                    /*items: [
                        {
                            id: null,
                            name: '',
                        },
                    ],*/
                }],
            ];
        },

        removeSolution(index) {
            this.solutions.splice(index, 1);
        },

        addStage() {
            this.stages.push({
                sort: this.stages.length,
                title: '',
                subtitle: '',
                description: '',
            });
        },
    },

    components: {
        SvCheckbox,
        SvDatePicker,
        SvRadio,
        SvInput,
        SvSelect,
        SvMap,
        SvButton,
        SvSelectList,
        SvInputList,
        SvSelectInputList,
        SvDoubleInputList,
        SvUpload,
        SvTextarea,
        SvMultipleInputs,
        SolutionEmpty,
        SolutionForm,
    },
};
</script>

<style lang="scss">
.digital-edit__button-top {
    position: fixed;
    right: 50px;
    bottom: 50px;
    z-index: 999;
}

.digital-edit__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.digital-edit__form-title {
    display: flex;
    justify-content: flex-end;
    margin-right: 49px;
    align-items: center;
    text-align: right;
    padding-left: 30px;

    &--start {
        align-items: flex-start;
    }
}

.digital-edit__form-item {
    display: grid;
    grid-template-columns: 291px 1fr;
    margin-top: 26px;
}

.digital-edit__form-item_section-title {
    margin-top: 60px;
}

.digital-edit__form-item_section-title_section-title-first {
    margin-top: 10px;
}

.digital-edit__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.digital-edit__form-elements--small {
    width: 311px;

    &.radio {
        display: flex;
    }
}

.digital-edit__form {
    padding: 50px 0;
}

.digital-edit__form-radio {
    margin-right: 21px;
}

.digital-edit__form-separator {
    min-width: 70px;
    text-align: center;
}

.digital-edit__form-elements--medium {
    width: 495px;

    &.ext_features {
        .sv-input__wrapper {
            width: 100%;
        }

    }
}

.digital-edit__form-elements--flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.digital-edit__form-elements--flex-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}

.digital-edit__form-elements--grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px 40px;
    align-items: flex-start;
    margin-bottom: 10px;

    .sv-checkbox__content {
        white-space: nowrap;
    }
}


.digital-edit__actions {
    display: flex;
    align-items: center;
    height: 100%;
}

.digital-edit__search {
    width: 47%;
    min-width: 280px;
}

.digital-edit__section-title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
}

.digital-edit-plans__form {
    display: grid;
    grid-template-columns: repeat(2, 260px);
    grid-gap: 30px;
    margin-top: 50px;
    margin-bottom: 50px;
}

.mb20 {
    margin-bottom: 20px;
}
</style>
